<div class="row container-header container-responsive">
  <div class="col-md-12 col-lg-6 mb-4">
    <h3 class="font-weight-normal">Registro - <strong>Cliente Enex Express+</strong></h3>
  </div>
</div>
<div class="col-12">
  <div class="card col-12 col-md text-left pl-auto mb-4">



    <div class="row" *ngIf="paginaActual < 4">

      <div class="col-12 d-flex justify-content-between mt-5 align-items-start">

        <div class="stage w-100" [ngClass]="{ 'active': paginaActual === 1 }" (click)="goToPage(1)">
          <div class="circule">1</div>
          <p class="text-center">Información de contacto</p>          
        </div>

        <div class="stage w-100" [ngClass]="{ 'active': paginaActual === 2 }" (click)="goToPage(2)">
          <div class="circule">2</div>
          <p class="text-center">Información de despacho</p>          
        </div>

        <div class="stage w-100" [ngClass]="{ 'active': paginaActual === 3 }" (click)="goToPage(3)">
          <div class="circule">3</div>
          <p class="text-center">Información de facturación</p>          
        </div>      

      </div>

    </div>




    <hr *ngIf="paginaActual < 4" />

    <ng-container *ngIf="paginaActual === 1">

      <form [formGroup]="infoPersonalForm" (submit)="handleSubmitInfoPersonal()">

        <div class="row">

          <div class="col-12 mb-4">
            <p class="mb-0 px-2">
              (*) Ingresa tus datos de contacto para poder comunicarnos contigo en caso de ser necesario.
            </p>
          </div>         
          
          <div class="col-12">
            <div class="form-row">
              <div class="col-12 col-md-6 form-group input-icon mb-3">
                <label class="mb-0" for="inErRut">Rut</label>
                <input type="text" maxlength="12" appInputRut formControlName="rut" name="rut" type="text"
                  autocomplete="off" inputmode="text" placeholder="Ingresa tu RUT" minlength="8" class="form-control"
                  id="inErRut" autofocus>
                <div class="invalid-feedback">
                  Debes ingresar un RUT válido.
                </div>
              </div>

              <div class="col-12 col-md-6 form-group input-icon mb-3">
                <label class="mb-0" for="inErNombre">Nombre</label>
                <input type="text" maxlength="50" formControlName="nombre" name="nombre" type="text"
                  class="form-control" id="nombre" placeholder="Ingresa tu nombre" autocomplete="off"
                  class="form-control" id="inErNombre">
                <div class="invalid-feedback">
                  <ng-container *ngIf="!ipf.nombre?.errors?.minlength">Debes ingresar un nombre válido.</ng-container>
                  <ng-container *ngIf="ipf.nombre?.errors?.minlength">Debes ingresar mínimo 5 caracteres.</ng-container>              
                  
                </div>
              </div>
            </div>

            <div class="form-row">

              <div class="col-12 col-md-6 form-group input-icon mb-3">
                <label class="mb-0" for="inErCelular">Número de celular</label>
                <div class="input-group tel-input">
                  <span>+56</span>
                  <input type="text" maxlength="9" type="text" inputmode="numeric" autocomplete="off" appInputNumber
                    placeholder="Ingresa tu celular" formControlName="celular" name="celular" class="form-control"
                    id="inErCelular">
                  <div class="invalid-feedback">
                    Debes ingresar un número de celular válido.
                  </div>
                </div>

              </div>

              <div class="col-12 col-md-6 form-group input-icon mb-3">
                <label class="mb-0" for="inErConfirmCelular">Confirma tu número de celular</label>
                <div class="input-group tel-input">
                  <span>+56</span>
                  <input type="text" maxlength="9" type="text" inputmode="numeric" autocomplete="off" appInputNumber
                    placeholder="Confirma tu celular" formControlName="confirmCelular" name="confirmCelular"
                    class="form-control" id="inErConfirmCelular">

                  <div class="invalid-feedback">
                    Los números de celular ingresados no coinciden.
                  </div>
                </div>
              </div>
            </div>


            <div class="form-row">
              <div class="col-12 col-md-6 form-group input-icon mb-3">
                <label class="mb-0" for="inErMail">Correo electrónico</label>
                <input type="text" maxlength="50" type="email" autocomplete="off" placeholder="Ingresa tu correo electrónico"
                  formControlName="email" name="email" class="form-control" id="inErMail">
                <div class="invalid-feedback">
                  Debes ingresar un correo válido.
                </div>
              </div>

              <div class="col-12 col-md-6 form-group input-icon mb-3">
                <label class="mb-0" for="inErConfirmMail">Confirma tu correo electrónico</label>
                <input type="text" maxlength="50" type="email" autocomplete="off" placeholder="Confirma tu correo electrónico"
                  formControlName="confirmEmail" name="confirmEmail" class="form-control" id="inErConfirmMail">
                <div class="invalid-feedback">
                  Los correos ingresados no coinciden.
                </div>
              </div>

            </div>

            <div class="form-row">
              <div class="col-12 mt-4 d-flex justify-content-end">
                <button type="submit" class="btn btn-success btn-md mr-0 mr-md-3 mb-3 mb-md-0 px-5" id="eex-paso-1"> Continuar </button>
              </div>
            </div>


          </div>
        </div>

      </form>
    </ng-container>


    <!-- CONTACTO Y DESPACHO-->
    <ng-container *ngIf="paginaActual === 2">

      <form [formGroup]="infoDespachoForm" (submit)="handleSubmitInfoDespacho()">

        <div class="row">

          <div class="col-12 mb-4">
            <p class="mb-0 px-2">
              (*) Consideración: no se realizarán despachos de combustible desde la vía pública.
            </p>
          </div>


          <div class="col-12">

            <div class="form-row">
              <div class="col-12 col-md-12 form-group mb-3">
                <label class="mb-0" for="inErDireccion">Dirección</label>
                <input type="text" maxlength="200" formControlName="direccion" name="direccion" autocorrect="off"
                  autocapitalize="off" spellcheck="off" inputmode="text" placeholder="Ingresa tu dirección"
                  class="form-control" id="inErDireccion" (focusout)="handleChangeAddress()" #search autofocus>
                <div class="invalid-feedback">
                  Debes ingresar una dirección válida.
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-12 col-md-4 form-group mb-2">
                <label class="mb-0" for="inErRegion">Región</label>
                <input type="text" id="inErRegion" class="form-control" formControlName="region" name="region" maxlength="50" (focusout)="handleChangeAddress()">
                <div class="invalid-feedback">
                  Debes ingresar una región válida.
                </div>
              </div>

              <div class="col-12 col-md-4 form-group mb-2">
                <label class="mb-0" for="inErCiudad">Provincia</label>
                <input type="text" id="inErCiudad" class="form-control" formControlName="cuidad" name="cuidad" maxlength="50" (focusout)="handleChangeAddress()">
                <div class="invalid-feedback">
                  Debes ingresar una provincia válida.
                </div>
              </div>

              <div class="col-12 col-md-4 form-group mb-2">
                <label class="mb-0" for="inErComuna">Comuna</label>
                <input type="text" id="inErComuna" class="form-control" formControlName="comuna" name="comuna" maxlength="50" (focusout)="handleChangeAddress()">
                <div class="invalid-feedback">
                  Debes ingresar una comuna válida.
                </div>
              </div>
            </div>

       
            <div class="row">
              <div class="col-12 mt-2">
                <agm-map class="my-2" [latitude]="lat" [longitude]="lng" [zoom]="zoom"
                (mapReady)="mapReadyHandler($event)">
                <agm-marker *ngIf="latitude && longitude" [latitude]="latitude" [longitude]="longitude"
                  [markerDraggable]="true" (dragEnd)="markerDragEnd($event)"></agm-marker>
              </agm-map>
              </div>
            </div>


             <div class="form-row mt-4">
              <div class="col-12 col-md-12 form-group mb-0">
                <label class="mb-0" for="inErObservacion">Observaciones (Opcional)</label>
               <textarea name="observacion" id="inErObservacion" formControlName="observacion" class="form-control text-area-h" rows="10" maxlength="150"
               placeholder="Detalles sobre el lugar de despacho (sólo se deben ingresar datos relacionados con la dirección de despacho)"></textarea>
                <div class="invalid-feedback">
                  Máximo 150 caracteres.
                </div>
              </div>
            </div>

            <div class="form-row mb-3 d-flex mt-4">

              <div class="col-12 col-md-6">
                <div class="col-12 px-0">
                  <label class="mb-0" for="inErComuna">¿Quién recibe el pedido?</label>
                </div>
                <div class="col-12">
                  <div class="form-check form-check-inline material-control">
                    <input class="form-check-input" type="radio" name="quienRecibe" id="inReciveYo" value="yo"
                      formControlName="quienRecibe">
                    <label class="form-check-label" for="inReciveYo">Yo</label>
                  </div>
                  <div class="form-check form-check-inline material-control">
                    <input class="form-check-input" type="radio" name="quienRecibe" id="inReciveOtro" value="otro"
                      formControlName="quienRecibe">
                    <label class="form-check-label" for="inReciveOtro">Otra persona</label>
                  </div>
                </div>

              </div>
            </div>

            <div class="form-row mb-4 d-flex">
              <div class="col-12 col-md-4 form-group input-icon mb-3">
                <label class="mb-0" for="nombreRecibe">Nombre de quién recibe</label>
                <input type="text" maxlength="50" formControlName="nombreRecibe" name="nombreRecibe" type="text"
                  class="form-control" id="nombreRecibe" placeholder="Ingresar nombre" autocomplete="off"
                  class="form-control" id="inErNombre">
                <div class="invalid-feedback">
                  <ng-container *ngIf="!idf.nombreRecibe?.errors?.minlength">Debes ingresar un nombre válido.</ng-container>
                  <ng-container *ngIf="idf.nombreRecibe?.errors?.minlength">Debes ingresar mínimo 5 caracteres.</ng-container>
                </div>
              </div>

              <div class="col-12 col-md-4 form-group input-icon mb-3">
                <label class="mb-0" for="inRecCelular">Número de celular de quién recibe</label>
                <div class="input-group tel-input">
                  <span>+56</span>
                  <input type="text" maxlength="9" type="text" inputmode="numeric" autocomplete="off" appInputNumber
                    placeholder="Ingresar celular" formControlName="celularRecibe" name="celularRecibe"
                    class="form-control" id="inRecCelular">
                  <div class="invalid-feedback">
                    Debes ingresar un número de celular válido.
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-12 col-md-6 form-group mb-3">
                <label class="mb-0" for="inErDistancia">Distancia entre el camión y el estanque (metros)</label>
                <input type="text" id="inErDistancia" appInputDecimalFormat maxlength="5" class="form-control"
                  formControlName="distanciaCamion" placeholder="12,9">
                <div class="invalid-feedback">

                  <ng-container *ngIf="!idf.distanciaCamion?.errors?.decMax">Debes ingresar un número entre 1 y 15.</ng-container>
                  <ng-container *ngIf="idf.distanciaCamion?.errors?.decMax">El valor máximo permitido es de 15 metros.</ng-container>
                  
                </div>
              </div>

              <div class="col-12 col-md-6 form-group mb-3">
                <label class="mb-0" for="inErCapEstanque">Capacidad del estanque (litros)</label>
                <input type="text" appInputNumberFormat maxlength="7" id="inErCapEstanque" class="form-control"
                  formControlName="capacidadEstanque" placeholder="1.000">
                <div class="invalid-feedback">
                  Debes ingresar un número mayor o igual a 200.
                </div>
              </div>
            </div>

            <div class="form-row mb-4">
              <div class="col-12 col-md-6 form-group mb-3">
                <label class="mb-0" for="inErTipoEstanque">Tipo de estanque</label>

                <ng-select id="inErTipoEstanque" [items]="tiposEstanque" bindLabel="descripcion" [clearable]="false" [notFoundText]="'Sin coincidencias'"
                  placeholder="Selecciona" formControlName="tipoEstanque" class="custom-ng-select">
                </ng-select>
                <div class="invalid-feedback">
                  Debes seleccionar un valor.
                </div>


              </div>

              <div class="col-12 col-md-6 form-group mb-3">
                <label class="mb-0" for="inErVentanaHoraria">Ventana horaria de recibimiento</label>

                <ng-select id="inErVentanaHoraria" [items]="tiposVentansHorarias" bindLabel="descripcion" [clearable]="false" [notFoundText]="'Sin coincidencias'"
                  placeholder="Selecciona" formControlName="ventanaHoraria"  class="custom-ng-select">
                </ng-select>
                <div class="invalid-feedback">
                  Debes seleccionar un valor.
                </div>
              </div>
            </div>


            <div class="form-row">
              <div class="col-12 col-md-6 mb-3">
                <label class="mb-0">Foto del estanque <i
                    class="bi bi-question-circle-fill  fs-18 text-dark-50" container="body"
                    [ngbTooltip]="'Incluir foto panorámica'"></i></label>
                <app-upload-files [labelFormatAceptString]="'Imagen'" (fileList)="setFotosEstanque($event)" [persistanFiles]="filelistFotosEstanque"
                  [fileFormatAcept]="imagesAcept"></app-upload-files>

                  <div class="invalid-feedback d-block mt-0" *ngIf="errorFilesDespacho.fotosEstanque">
                    Debe cargar un archivo válido.
                  </div>
              </div>
            </div>
              <div class="form-row">

              <div class="ol-12 col-md-6 mb-3" *ngIf="isShowCertificacionCapacidadEstanque">
                <label class="mb-0">Inscripción TC4 (certificado capacidad del estanque)</label>
                <app-upload-files [maxFiles]="4" (fileList)="setCapacidadEstanque($event)" [persistanFiles]="filelistCapacidadEstanque"></app-upload-files>
                <div class="invalid-feedback d-block mt-0" *ngIf="errorFilesDespacho.capacidadEstanque">
                  Debe cargar un archivo válido.
                </div>
              </div>
            </div>
            <div class="form-row">

              <div class="ol-12 col-md-6 mb-3" *ngIf="isShowTipoTanqueEstanque">
                <label class="mb-0">Certificado de hermeticidad TC8 de tanque y línea enterrados</label>
                <app-upload-files [maxFiles]="4" (fileList)="setTipoEstanque($event)" [persistanFiles]="filelistTipoEstanque"></app-upload-files>
                <div class="invalid-feedback d-block mt-0" *ngIf="errorFilesDespacho.tipoEstanque">
                  Debe cargar un archivo válido.
                </div>
              </div>
            </div>

            <div class="form-row d-flex justify-content-end">

              <div class="col-6 col-md-4 col-lg-3">
                <button type="button" (click)="goToPage(1)" class="btn btn-outline-green btn-md mr-3 mb-3 px-4 px-md-5 mb-md-0 w-100"> Volver </button>
              </div>

              <div class="col-6 col-md-4 col-lg-3">
                <button type="submit" class="btn btn-success btn-md mr-0 mr-md-3 mb-3 px-4 px-md-5 mb-md-0 w-100" id="eex-paso-2"> Continuar </button>
              </div>

            </div>
          </div>
        </div>
      </form>


    </ng-container>


    <ng-container *ngIf="paginaActual === 3">

      <form [formGroup]="infoFacturacionForm" (submit)="handleSubmitInfoFacturacion()">

        <div class="row">
          <div class="col-12">


            <div class="form-row mb-3 d-flex mt-4">

              <div class="col-12 col-md-6">
                <div class="col-12 px-0">
                  <label class="mb-0">Tipo de cliente</label>
                </div>
                <div class="col-12">
                  <div class="form-check form-check-inline material-control">
                    <input class="form-check-input" type="radio" name="tipoPersona" id="inFaTipoClienteNat" value="Persona natural"
                      formControlName="tipoPersona">
                    <label class="form-check-label" for="inFaTipoClienteNat">Persona natural</label>
                  </div>
                  <div class="form-check form-check-inline material-control">
                    <input class="form-check-input" type="radio" name="tipoPersona" id="inFaTipoClienteCom" value="Comercial"
                      formControlName="tipoPersona">
                    <label class="form-check-label" for="inFaTipoClienteCom">Comercial</label>
                  </div>
                </div>

              </div>
              </div>
              <div class="form-row d-flex mt-4">

              <div class="col-12 col-md-4 form-group input-icon mb-3">
                <label class="mb-0" for="inFaNombre">Razón social</label>
                <input type="text" maxlength="50" formControlName="razonSocial" name="razonSocial" type="text"
                  class="form-control"  placeholder="Ingresa la razón social" autocomplete="off"
                  class="form-control" id="inFaNombre">
                <div class="invalid-feedback">
                  Debes ingresar una razón social válida.
                </div>
              </div>

              <div class="col-12 col-md-4 form-group input-icon mb-3">
                <label class="mb-0" for="inFaRut">Rut</label>
                <input type="text" maxlength="12" appInputRut formControlName="rut" name="rut" type="text"
                  autocomplete="off" inputmode="text" placeholder="Ingresa el RUT de la empresa" minlength="8" class="form-control"
                  id="inFaRut">
                <div class="invalid-feedback">
                  Debes ingresar un RUT válido.
                </div>
              </div>

            </div>


            <div class="form-row">
              <div class="col-12 col-md-4 form-group input-icon mb-3">
                <label class="mb-0" for="inFaGiroComercial">Giro comercial</label>
                <input type="text" maxlength="50" formControlName="giro" name="giro" type="text"
                  class="form-control"  placeholder="Ingresa el giro comercial" autocomplete="off" id="inFaGiroComercial">
                <div class="invalid-feedback">
                  Debes ingresar un giro válido.
                </div>
              </div>



              <div class="col-12 col-md-4 form-group mb-3">
                <label class="mb-0" for="inFaSegmento">Segmento</label>

                <ng-select id="inFaSegmento" [items]="tiposSegmentos" bindLabel="descripcion" [clearable]="false" [notFoundText]="'Sin coincidencias'"
                  placeholder="Seleccionar" formControlName="segmento" class="custom-ng-select">
                </ng-select>
                <div class="invalid-feedback">
                  Debes seleccionar un valor.
                </div>
              </div>
            </div>


            <div class="form-row">



             



              <div class="col-12">
                <label class="mb-2" for="inFaDireccion">Dirección de facturación</label>

                <div class="col-12 pl-0 mb-2">
                  <div class="form-check form-check-inline material-control">
                    <input class="form-check-input" type="checkbox" name="mismaDireccion" id="inFaUseDireccion" value="true"
                      formControlName="mismaDireccion">
                    <label class="form-check-label" for="inFaUseDireccion">Usar mi dirección como dirección de facturación</label>
                  </div>
                </div>
               
                <!-- <div class="form-group form-check mb-1">
                  <input type="checkbox" class="form-check-input" id="inFaUseDireccion" name="mismaDireccion" formControlName="mismaDireccion">
                  <label class="form-check-label" for="inFaUseDireccion" >Usar mi dirección como dirección de facturación</label>
                </div> -->
              </div>

            </div>

            <div class="form-row">
              <div class="col-12 col-md-12 form-group mb-3">
                
                <input type="text" maxlength="200" formControlName="direccion" name="direccion" autocorrect="off"
                  autocapitalize="off" spellcheck="off" inputmode="text" placeholder="Ingresa tu dirección de facturación"
                  class="form-control" id="inFaDireccion" #searchFact>
                <div class="invalid-feedback">
                  Debes ingresar una dirección válida.
                </div>
              </div>
            </div>

            <div class="row" *ngIf="!iff.mismaDireccion.value">
              <div class="col-12 mb-4">
                <agm-map class="my-2" [latitude]="latFac" [longitude]="lngFac" [zoom]="zoom"
                (mapReady)="mapReadyHandlerFac($event)">
                <agm-marker *ngIf="latitudeFac && longitudeFac" [latitude]="latitudeFac" [longitude]="longitudeFac"
                  [markerDraggable]="true" (dragEnd)="markerDragEndFac($event)"></agm-marker>
              </agm-map>
              </div>
            </div>



            <div class="form-row">
              <div class="col-12 form-group d-flex justify-content-center">
                <div class="custom-input-group mb-3">
                  

                  <div class="form-check form-check-inline material-control">
                    <input class="form-check-input" type="checkbox" name="terminos" id="inFaTerminosCondicioones" value="true"
                      formControlName="terminos">
                    <label class="form-check-label" for="inFaTerminosCondicioones">He leído y acepto los <a class="fs-16" href="./assets/docs/Terminos_y_condiciones.pdf" target="_blank">Términos y condiciones de Enex Express+</a> y las Políticas de Privacidad</label>
                  </div>
                  <div class="invalid-feedback d-block ml-0 pl-0 ml-lg-4 pl-lg-1" *ngIf="iff.terminos.errors && iff.terminos.touched">
                    Debes aceptar los Términos y condiciones de Enex Express+ y las Políticas de Privacidad para continuar.
                  </div>
                </div>               
              </div>
            </div>





            <div class="form-row">
              <div class="col-12 form-group d-flex flex-column align-items-center">
                <div class="custom-input-group mb-3">
                  <re-captcha
                    (resolved)="resolved($event)"
                    [siteKey]="googleCaptchaSiteKey"
                    formControlName="recaptchaReactive"
                  ></re-captcha>

                  <div class="invalid-feedback d-block" *ngIf="iff.recaptchaReactive.errors && iff.recaptchaReactive.touched">
                    El reCAPTCHA es obligatorio.
                  </div>
                </div>
                
              </div>
            </div>


            <div class="row justify-content-center" *ngIf="isError">
              <div class="col-12 col-md-8">
                <div class="alert alert-danger" role="alert">
                  Ha ocurrido un error al enviar el formulario, por favor inténtelo nuevamente.
                </div>
              </div>
            </div>

            <app-loader-full *ngIf="isLoading"></app-loader-full>

            <div class="form-row d-flex justify-content-end">

              <div class="col-6 col-md-4 col-lg-3">
                <button type="button" (click)="goToPage(2)" class="btn btn-outline-green btn-md mr-3 mb-3 px-4 px-md-5 mb-md-0 w-100"> Volver </button>
              </div>

              <div class="col-6 col-md-4 col-lg-3">
                <button type="submit" class="btn btn-success btn-md mr-0 mr-md-3 mb-3 px-4 px-md-5 mb-md-0 w-100" id="eex-paso-3"> Finalizar </button>
              </div>

            </div>

          </div>
        </div>
      </form>


    </ng-container>


    <ng-container *ngIf="paginaActual === 4">

      <div class="row">
        <div class="col-12 d-flex align-items-center mt-4">

          <i class="bi bi-check-circle-fill big-icon mr-4"></i>

          <div>
            <h2>Gracias por registrarte en nuestro servicio Enex Express+</h2>
            <p class="mb-0">Validaremos tus datos y nos pondremos en contacto contigo vía correo electrónico en un máximo de 48 horas hábiles para que puedas realizar el pedido a través de nuestro portal.</p>
          </div>
         
        </div>

        <div class="col-12 mt-4 d-flex align-items-center justify-content-center">
          <button type="button" (click)="goToLogin()" class="btn btn-success btn-md mr-0 mr-md-3 mb-3 px-4 px-md-5 mb-md-0"id="eex-volver-inicio"> Volver al inicio</button>
        </div>
      </div>

  

    </ng-container>
  </div>
</div>

<ng-template #tmpLoader>
  <span class="spinner-border text-white" role="status">
    <span class="sr-only">Loading...</span>
  </span>
</ng-template>